<app-frame [overlay]="false" [title]="'Alert'"   (neadClose)="closeForm()" autocomplete="off" class="summaries-frame">

	<iframe id="notificationAlert" target="_parent" style="width: 60vw; height: 80vh;"></iframe>

</app-frame>

